import {
  AfterContentChecked,
  AfterContentInit, ChangeDetectorRef,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList
} from '@angular/core';
import { TabPanelComponent } from './tab-panel.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tab-view',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './tab-view.component.html'
})
export class TabViewComponent implements AfterContentInit, AfterContentChecked {

  @Input()
  public centered = false;

  @Input()
  public simple = false;

  @Output()
  public onAddNew = new EventEmitter<Event>();

  @Input()
  public showAddButton = false;

  @Input()
  public addBtnTitle: string = 'Dodaj zakładkę';

  public selected: TabPanelComponent | undefined;

  @ContentChildren(TabPanelComponent)
  tabPanels: QueryList<TabPanelComponent> | undefined;

  public panels: TabPanelComponent[] = [];

  constructor(public ref: ChangeDetectorRef) {
  }

  public close(event: Event, p: TabPanelComponent): void {
    event.preventDefault();
    event.stopPropagation();
    if (!p.closeBtnDisabled) {
      p.onClose.emit();
    }
  }

  public addNew(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.onAddNew.emit(event);
  }

  public onNavigate(item?: TabPanelComponent, event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    if (item?.disabled) {
      return;
    }
    this.panels?.forEach(v => v.selected = false);
    item!.selected = true;
    this.selected = item;
  }

  public loadPanels(): void {
    this.panels = this.tabPanels?.toArray() || [];
    this.panels.forEach(v => {
      if (v.selected && !v.disabled) {
        this.selected = v;
      }
    });
  }

  public ngOnInit(): void {
  }

  public ngAfterContentInit(): void {
    this.loadPanels();
  }

  public ngAfterContentChecked(): void {
    const newPanels = this.tabPanels?.toArray() || [];
    if (this.panels.length !== (newPanels)?.length) {
      this.loadPanels();
    }
  }
}
